import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  deleteHorariosAction,
  setActivoHorariosAction,
} from '../HorariosAction';
import { getDataHorario } from '../HorariosView';

const ListadoHorarios = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const horariosStore = Redux.useSelector((state) => state.horarios);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    setRows([]);
    setRows(
      horariosStore.all.map(({ horaInicio, horaFinal, estatus, ...rest }) => ({
        ...rest,
        horas: `${horaInicio}-${horaFinal}`,
        estatus: estatus.nombre,
      })),
    );
  }, [horariosStore.all]);

  const _handleEditClick = async (id) => {
    const data = horariosStore.all.find((el) => el.id === id);
    await setActivoHorariosAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteHorariosAction(
      { dispatch, notify },
      horariosStore.activo.id,
      horariosStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
    setLoadingDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      label: 'ID',
      options: {
        filter: false,
      },
    },
    {
      name: CONST.docente.name,
      label: CONST.docente.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value.usuario.perfil.pnombre} {value.usuario.perfil.papellido}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.materia.name,
      label: CONST.materia.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography variant="body1" color="initial">
              {value?.nombre}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.seccion.name,
      label: CONST.seccion.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography variant="body1" color="initial">
              {value?.nivelAcademico.nivelAcademico.nombre}
              {'-'}
              {value?.nombre}
              {'-'}
              {value?.turno}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.dia.name,
      label: CONST.dia.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.horas.name,
      label: CONST.horas.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = horariosStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoHorariosAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  const data = horariosStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  window.open(data.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },

    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={horariosStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {horariosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          {getDataHorario(loginStore.isAdminTeacher, horariosStore.activo)}
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoHorarios;
